export default __webpack_public_path__ + "static/media/manifest.ea5ab8cd.webmanifest";